import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorEducationAddLoader = async () => {

    const getModulesResponse = await networkCall('/modules');

    return { getModulesResponse };

};